import { render, staticRenderFns } from "./AttachmentsSection.vue?vue&type=template&id=0849b35e&scoped=true&"
import script from "./AttachmentsSection.vue?vue&type=script&lang=js&"
export * from "./AttachmentsSection.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsSection.vue?vue&type=style&index=0&id=0849b35e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0849b35e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
